import { Row } from '@christiankaindl/lyts'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import Link from 'next/link'
import { Desktop, Mobile } from '../MediaQuery/MediaQuery'
import * as styles from './NavBar.css'

import Button from '@shared/components/Button/Button'
import { NavBarSearch } from './NavBarSearch'
import logoHorizontalAT from '@shared/assets/gesetzefinden-at-logo-horizontal.png'
import logoHorizontalDE from '@shared/assets/gesetzefinden-de-logo-horizontal.png'
import NavBarMenus from './NavBarMenus'
import { newPost } from '@/app/index.css'
import { ChevronRightIcon, ExternalLinkIcon } from 'lucide-react'
import Background from './Background'
import SignedInUserButton from './SignedInUserButton'
import { SignInButton, SignedIn, SignedOut } from './Auth'
import { appName, isDeJurisdiction } from '@shared/lib/jurisdiction'
import { isDev } from '@shared/lib/utils'

const logoHorizontal = isDeJurisdiction ? logoHorizontalDE : logoHorizontalAT
import codaraLogo from '@shared/assets/codara-favicon.png'

const codaraUrl = isDev
  ? 'https://dev-dashboard.codara.com'
  : 'https://dashboard.codara.com'

const SearchOverlay = dynamic(async () => await import('./MobileSearchOverlay'))

const featuredPost = {
  title: `Von ${appName} zu Codara`,
  href: '/blog/von-gesetzefinden-zu-codara',
}

/**
 * `ghost` is the top-of-homepage state: the hero already has a big search field
 * and the logo, so the bar collapses to the small logo plus the featured post.
 */
function NavbarContent({ ghost = false }: { ghost?: boolean }) {
  return (
    <>
      <Mobile style={{ display: 'flex', alignItems: 'center' }}>
        <SearchOverlay />
      </Mobile>

      <Row gap={0.75}>
        <Link
          href='/'
          className={styles.logo}
          style={{ width: ghost ? undefined : '14.25em' }}
        >
          <Image
            src={logoHorizontal}
            alt='Logo von GesetzeFinden.at'
            style={{
              height: 32,
              width: ghost ? 35 : 'auto',
              objectFit: 'cover',
              objectPosition: 'left',
            }}
            priority
          />
        </Link>

        {!ghost && <NavBarSearch />}
        <NavBarMenus />
      </Row>

      {ghost ? (
        <Button circular href={featuredPost.href} className={newPost}>
          <Row
            gap={0.25}
            style={{
              borderRadius: 99,
              backgroundColor: 'white',
              padding: '4px 12px',
              marginLeft: -6,
              fontSize: '0.9em',
            }}
          >
            <span>BLOG</span>
          </Row>
          {featuredPost.title}
          <ChevronRightIcon size={16} style={{ marginRight: -6 }} />
        </Button>
      ) : (
        <div />
      )}

      <Row
        asChild
        xAlign='space-between'
        style={{ justifySelf: 'end' }}
        gap={0.25}
      >
        <Desktop>
          <SignedIn>
            <Button href={codaraUrl} variant='flat' circular>
              <Image
                src={codaraLogo}
                alt='Codara Logo'
                width={24}
                height={24}
                style={{ borderRadius: 99 }}
              />
              Dashboard
              <ExternalLinkIcon size={14} />
            </Button>
            <SignedInUserButton />
          </SignedIn>
          <SignedOut>
            <SignInButton />
          </SignedOut>
        </Desktop>
      </Row>

      {/* Use an absolutely positioned element for the backdrop-blur, beacause there are rendering issues in Chrome with nested blurs */}
      {!ghost && <Background />}
    </>
  )
}

export default NavbarContent
